<template>
    <div>
        <v-col cols="12">
            <h2 class="mt-4 mb-0">{{ title }}</h2>
            <b-datatable
                ref="grid"
                :key="datatableKey"
                :columns="columns"
                :endpoint="listRoute"
                :hidden-columns="hiddenColumns"
                :initial-filters="initialFilters"
                :keep-filters="false"
            >
                <template #filters="{ filters }">
                    <v-col cols="4" class="pb-0">
                        <b-filter-input
                            v-model="filters.filters.title"
                            label="Title"
                            placeholder="Search by title"
                        ></b-filter-input>
                    </v-col>
                </template>
                <template #buttons>
                    <div v-if="!onlyManuals" class="px-2">
                        <v-tooltip top transition="v-fab-transition">
                            <template #activator="{ on, attrs }">
                                <v-btn
                                    v-if="can('documents.create')"
                                    color="primary"
                                    icon
                                    v-bind="attrs"
                                    @click="goToUploadDocument"
                                    v-on="on"
                                >
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                            </template>
                            <span>Upload Document</span>
                        </v-tooltip>
                    </div>
                </template>
                <template #[`item.visible`]="{ item }">
                    <v-icon v-if="item.visible" color="success">mdi-check</v-icon>
                    <v-icon v-else color="error">mdi-close</v-icon>
                </template>
                <template #[`item.effective_date`]="{ item }">
                    {{ moment(item.effective_date).format('DD-MM-YYYY') }}
                </template>
                <template #[`item.section`]="{ item }">
                    <span>{{ _.startCase(item.section) }}</span>
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-tooltip top transition="v-fab-transition">
                        <template #activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="downloadItem(item)">
                                <v-icon>mdi-download</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ t('quality-control::button.download_file') }}</span>
                    </v-tooltip>
                    <v-tooltip v-if="can('api.v1.documents.update') && !onlyManuals" top transition="v-fab-transition">
                        <template #activator="{ on, attrs }">
                            <v-btn
                                color="disabled-color"
                                icon
                                v-bind="attrs"
                                v-on="on"
                                @click="$root.goTo(editItemUrl(item))"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ t('users::button.edit') }}</span>
                    </v-tooltip>
                    <b-delete
                        v-if="can('api.v1.documents.destroy') && !onlyManuals"
                        title="Delete Document"
                        text="Are you sure you want to delete this document?"
                        icon="mdi-trash-can"
                        :path="deleteItemUrl(item)"
                        @deleted="triggerDeleted"
                    >
                    </b-delete>
                </template>
            </b-datatable>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
        onlyManuals: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    data() {
        return {
            title: this.onlyManuals ? 'User Manuals' : 'Documents',
            datatableKey: 1,
            selectedItems: [],
            columns: this.setInitialColumns(),
            hiddenColumns: ['id'],
            initialFilters: this.setInitialFilters(),
        };
    },
    methods: {
        setInitialFilters() {
            if (this.onlyManuals) {
                return {
                    section: 'user_manuals',
                    visible: true,
                };
            }

            return {};
        },
        setInitialColumns() {
            let columns = [
                {
                    text: t('default::grid.label.id'),
                    value: 'id',
                    sortable: false,
                    width: 170,
                },
                {
                    text: t('default::grid.label.title'),
                    value: 'title',
                    sortable: true,
                    width: 400,
                },
            ];

            if (this.onlyManuals) {
                return columns.concat([
                    {
                        value: 'actions',
                        class: 'actions',
                        cellClass: 'actions',
                        sortable: false,
                        fields: null,
                        align: 'end',
                    },
                ]);
            }

            return columns.concat([
                {
                    text: t('default::grid.label.section'),
                    value: 'section',
                    sortable: true,
                },
                {
                    text: t('default::grid.label.effective_date'),
                    value: 'effective_date',
                    sortable: true,
                },
                {
                    text: t('default::grid.label.visible'),
                    value: 'visible',
                    sortable: true,
                },
                {
                    value: 'actions',
                    class: 'actions',
                    cellClass: 'actions',
                    sortable: false,
                    fields: null,
                    align: 'end',
                },
            ]);
        },
        goToUploadDocument() {
            this.$root.goTo(route('documents.create'));
        },
        downloadItem(item) {
            return this.$root.goTo(route('documents.download', { file: item.file_id }));
        },
        deleteItemUrl(item) {
            return route('api.v1.documents.destroy', { document: item.id });
        },
        triggerDeleted() {
            this.datatableKey++;
            this.$root.notify('info', t('default::notification.deleted'));
        },
        editItemUrl(item) {
            return route('documents.get', { document: item.id });
        },
    },
};
</script>
